// This is a generated file!
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
require("./cancel-icon-sk");
